import { View, Text, hexColor } from "@lightningtv/solid";
import type { UserData } from "../../utils/accessToken";

interface HotelScreenProps {
  userData: UserData;
  deviceId: string;
  accent: string;
  // Finishes the login (playlist setup) and goes to Home
  onContinue: () => void;
  // Lets the licence screen give focus back after the exit modal closes
  screenRef?: { focus?: () => void };
}

// Shown after a successful login when the device belongs to a hotel property
// (property_data.type === "hotel"). Residential devices keep the existing
// flow and never see this screen.
const HotelScreen = (props: HotelScreenProps) => {
  let continueButtonRef: any;
  if (props.screenRef) props.screenRef.focus = () => continueButtonRef?.setFocus?.();

  const property = () => props.userData.property_data || {};

  return (
    <View
      x={140}
      y={360}
      width={600}
      height={560}
      borderRadius={30}
      style={{
        colorTop: hexColor("#000000B3"),
        colorBottom: hexColor("#000000F2"),
        border: { width: 2, color: hexColor(props.accent + "99") },
      }}
    >
      <View x={50} y={50} style={{ display: "flex", flexDirection: "column", gap: 24, width: 500 }}>
        <Text
          contain="width"
          style={{ fontSize: 36, color: hexColor(props.accent), fontWeight: "bold", width: 500, maxLines: 1 }}
        >
          {`Welcome to ${property().name || "our hotel"}`}
        </Text>

        <Text
          contain="width"
          style={{ fontSize: 22, lineHeight: 30, color: hexColor("#B9B9BE"), width: 500, maxLines: 2 }}
        >
          Your room TV is ready.
        </Text>

        <View
          width={500}
          height={110}
          borderRadius={20}
          style={{
            colorLeft: hexColor(props.accent + "66"),
            colorRight: hexColor("#1A1A1AE6"),
            border: { width: 2, color: hexColor(props.accent + "80") },
          }}
        >
          <Text x={28} y={20} style={{ fontSize: 18, color: hexColor("#B9B9BE"), letterSpacing: 2 }}>
            DEVICE ID
          </Text>
          <Text
            x={28}
            y={52}
            contain="width"
            style={{ fontSize: 34, color: hexColor("#ffffff"), fontWeight: "bold", width: 450, maxLines: 1 }}
          >
            {props.deviceId}
          </Text>
        </View>

        <View width={500} height={80}>
          <View
            ref={(el: any) => { continueButtonRef = el; }}
            x={125}
            autofocus
            onEnter={() => { props.onContinue(); return true; }}
            style={{
              width: 250,
              height: 80,
              borderRadius: 40,
              scale: 1,
              color: hexColor("#333333"),
              border: { width: 3, color: hexColor("#555555") },
              transition: {
                scale: { duration: 200, easing: "ease-in-out" },
                color: { duration: 200, easing: "ease-in-out" },
              },
              focus: {
                scale: 1.05,
                color: hexColor(props.accent),
                border: { width: 3, color: hexColor(props.accent) },
              },
            }}
          >
            <Text
              y={26}
              contain="width"
              textAlign="center"
              style={{ fontSize: 26, color: hexColor("#ffffff"), fontWeight: "bold", width: 250 }}
            >
              Continue
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default HotelScreen;
